<ax-value-view-label [label]="label">
  <span>{{ (value === 'true' ? 'label.on' : 'label.off') | translate }}</span>
</ax-value-view-label>
